const WishlistActiveHeartButtonIcon = ({
  iconType = 'filled',
  iconColor = '#DF2121',
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="11.7778"
        fill={iconType === 'filled' ? 'white' : 'none'}
        stroke={iconType === 'filled' ? '#E0E0E0' : 'none'}
        stroke-width="0.445154"
      />
      <path
        d="M12.1369 18.7992C12.0068 18.7992 11.8782 18.7757 11.7511 18.7287C11.6239 18.6816 11.5119 18.6098 11.4152 18.5132L10.6487 17.8217C9.46043 16.7432 8.41193 15.6946 7.50314 14.6757C6.59447 13.6567 6.14014 12.5978 6.14014 11.4988C6.14014 10.6504 6.42865 9.93807 7.00568 9.36174C7.5826 8.78529 8.29569 8.49707 9.14493 8.49707C9.63204 8.49707 10.1392 8.62003 10.6665 8.86595C11.1939 9.11176 11.6883 9.57547 12.1497 10.2571C12.6111 9.57547 13.1055 9.11176 13.6329 8.86595C14.1602 8.62003 14.6674 8.49707 15.1545 8.49707C16.0038 8.49707 16.7168 8.78529 17.2938 9.36174C17.8708 9.93807 18.1593 10.6504 18.1593 11.4988C18.1593 12.6234 17.6863 13.7043 16.7404 14.7417C15.7944 15.7791 14.759 16.807 13.6341 17.8255L12.8714 18.5132C12.7747 18.6098 12.6606 18.6816 12.5292 18.7287C12.3977 18.7757 12.267 18.7992 12.1369 18.7992Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default WishlistActiveHeartButtonIcon;
